var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2322_71",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2322_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0056 18.9422C16.2758 18.9422 17.3536 18.4976 18.239 17.6084C19.1244 16.7193 19.5671 15.6396 19.5671 14.3694C19.5671 13.0992 19.1225 12.0214 18.2334 11.1359C17.3442 10.2505 16.2645 9.80781 14.9943 9.80781C13.7241 9.80781 12.6463 10.2524 11.7609 11.1416C10.8755 12.0307 10.4328 13.1104 10.4328 14.3806C10.4328 15.6508 10.8773 16.7286 11.7665 17.6141C12.6557 18.4995 13.7354 18.9422 15.0056 18.9422ZM14.9999 17.75C14.0624 17.75 13.2656 17.4219 12.6093 16.7656C11.9531 16.1094 11.6249 15.3125 11.6249 14.375C11.6249 13.4375 11.9531 12.6406 12.6093 11.9844C13.2656 11.3281 14.0624 11 14.9999 11C15.9374 11 16.7343 11.3281 17.3906 11.9844C18.0468 12.6406 18.3749 13.4375 18.3749 14.375C18.3749 15.3125 18.0468 16.1094 17.3906 16.7656C16.7343 17.4219 15.9374 17.75 14.9999 17.75ZM15.0034 22.5C12.2959 22.5 9.82838 21.7632 7.60088 20.2897C5.74763 19.0637 4.28151 17.493 3.20252 15.5776C2.78196 14.831 2.78197 13.919 3.20244 13.1724C4.28111 11.257 5.74611 9.68627 7.59744 8.46031C9.82265 6.98677 12.289 6.25 14.9965 6.25C17.704 6.25 20.1715 6.98677 22.399 8.46031C24.2523 9.68628 25.7184 11.257 26.7974 13.1724C27.2179 13.919 27.2179 14.831 26.7974 15.5776C25.7188 17.493 24.2538 19.0637 22.4024 20.2897C20.1772 21.7632 17.7109 22.5 15.0034 22.5ZM14.9999 21.25C17.3541 21.25 19.5156 20.6302 21.4843 19.3906C23.0318 18.4163 24.293 17.1748 25.2677 15.6662C25.7756 14.8801 25.7756 13.8699 25.2677 13.0838C24.293 11.5752 23.0318 10.3337 21.4843 9.35937C19.5156 8.11979 17.3541 7.5 14.9999 7.5C12.6458 7.5 10.4843 8.11979 8.51557 9.35937C6.96804 10.3337 5.70692 11.5752 4.73221 13.0838C4.2243 13.8699 4.2243 14.8801 4.73221 15.6662C5.70692 17.1748 6.96804 18.4163 8.51557 19.3906C10.4843 20.6302 12.6458 21.25 14.9999 21.25Z",
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityIcon);
export default __webpack_public_path__ + "static/media/visibility-icon.a39b0e6ebc9f61d56e7243765212c247.svg";
export { ForwardRef as ReactComponent };